export default "/images/vendor/flag-icon-css/flags/4x3/bf.svg?4275eb85c53fe2d0f6a824dd028d8455";